// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__AmIl5","pulsate":"Loader_pulsate__XAL0x"};